import { render, staticRenderFns } from "./RevisionInfoModal.vue?vue&type=template&id=914db58c&"
import script from "./RevisionInfoModal.vue?vue&type=script&lang=js&"
export * from "./RevisionInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports